/**
 * Sticky header.
 */

const sticky_header = (args) => {
    // setup args
    let supplementary = args.supplementary;
    let main = args.main;
    let footer = args.footer;

    function init() {
        if (supplementary) {
            window.sticky_header_tools.makeBackwardsFocusable(supplementary);
        }
        if (main) {
            window.sticky_header_tools.makeBackwardsFocusable(main);
        }
        if (footer) {
            window.sticky_header_tools.makeBackwardsFocusable(footer);
        }
    }

    init();

    return this;
};

sticky_header({
    supplementary: document.querySelector('.js-site-supplementary'),
    main: document.querySelector('.js-site-main'),
    footer: document.querySelector('.js-site-footer'),
});
